module.exports = __webpack_public_path__ + "img/shield.e50940ac.png";